import API from "../utils/api";

const createAdjustment    = async (data)     => (await API.post(`/api/stock-adjustments`, data)).data;
const getAdjustments      = async (params)   => (await API.get(`/api/stock-adjustments`, { params })).data;
const getSingleAdjustment = async (id)       => (await API.get(`/api/stock-adjustments/${id}`)).data;
const updateAdjustment    = async (id, data) => (await API.put(`/api/stock-adjustments/${id}`, data)).data;
const deleteAdjustment    = async (id)       => (await API.delete(`/api/stock-adjustments/${id}`)).data;
const convertStock        = async (data) =>(await API.post(`/api/stock-adjustments/convert`, data)).data;

const stockAdjustmentService = {
  createAdjustment, getAdjustments,
  getSingleAdjustment, updateAdjustment, deleteAdjustment, convertStock
};
export default stockAdjustmentService;